<div class="confirm-dialog-container">
  <div class="menu">
    <span class="title">{{ title }}</span>
    <!--<span class="close" (click)="close()">X</span>-->
  </div>
  <div class="content mt-3">
    {{ contentMsg }}
  </div>
  <div class="btn-wrapper mt-3">
    <!-- <span *ngIf="isConfirm === true"> -->
    <input
      *ngIf="isConfirm === true"
      class="main-btn ms-2"
      type="submit"
      [value]="confirmBtnValue"
      (click)="confirm()"
    />
    <!-- <input class="btn btn-default confirm-btn" type="submit" [value]="confirmBtnValue" (click)="confirm()" /> -->
    <!-- </span> -->
    <!-- <span *ngIf="isDelete === true"> -->
    <input
      *ngIf="isDelete === true"
      class="btn btn-default delete-btn ms-2"
      type="submit"
      [value]="deleteBtnValue"
      (click)="delete()"
    />
    <!-- </span> -->
    <input *ngIf="cancelBtnValue != ''" class="outline-btn ms-2" type="submit" [value]="cancelBtnValue" (click)="cancel()" />
    <!-- <input class="btn btn-default cancel-btn" type="submit" [value]="cancelBtnValue" (click)="cancel()" /> -->
  </div>
</div>
